export default __webpack_public_path__ + "static/media/reparatie_motor.26add6c1.svg";